import React from 'react'
//Helpers
import { ElementHTML, getDescription } from '@helpers/helper.rendering'
import { Col, Container, Row } from 'react-bootstrap'
import useQueryProperty from '@hooks/useQueryProperty'
import { RealEstateDataPageComponentData } from 'types'

const titleProperty_1 = ({
  propertyID,
  title,
  titleElement,
  global_data,
}: { propertyID: string } & RealEstateDataPageComponentData) => {
  const { data: allPropertyData, isLoading } = useQueryProperty(
    propertyID,
    global_data.pageConfig.keys.tokko,
  )
  return (
    <section
      className="ficha-about prop a p-y-config"
      id="Descripcion"
    >
      {allPropertyData?.publication_title && (
        <Container fluid>
          <Row className="no-gutters">
            <Col xs={12}></Col>
            <Col xs={12}>
              <Row>
                <Col
                  lg={2}
                  className="col-lg-2"
                >
                  <ElementHTML
                    children={title || 'Concepto'}
                    elementType={titleElement || 'h4'}
                    className="mb-4 mb-lg-0 section-name"
                  />
                </Col>
                <Col lg={10}>
                  <p className={'description-ficha ' + (isLoading ? 'skeleton' : '')}>
                    {allPropertyData && allPropertyData?.publication_title}
                  </p>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      )}
    </section>
  )
}

export default titleProperty_1
